import { get, postWithToast } from 'utils/fetch';
import * as Types from './temlatesTypes.types';
import { AddDocumentTemplateModel } from 'api/api';

export const addDocumentTemplate = (props: Types.AddTemplateData) =>
    postWithToast('/DocumentTemplate/AddTemplate', props);

export const getExtendedDocumentTemplate = (search?: string) =>
    get<Types.AddTemplateData>(`/DocumentTemplate/ExtendedDocumentTypes`, {
        search
    });

export type ExtendedDocumentType =
    AddDocumentTemplateModel['extendedDocumentType'];
